const disneyKids = (function ($, fed) {
    window.dataLayer = window.dataLayer || [];
    const voucher = {
        httpStatusCode: {
            OK: 200,
            Created: 201,
            UnprocessableEntity: 422,
            LoginTimeout: 440,
            BadGateway: 502
        },
        elements: {
            generateVoucher: '#generate-button',
            issueVoucher: '#issueVoucher',
            addChildCover: '#add-child-cover',
            generateCodeButton: '#generate-code-button',
            generateCodeLoadingModal: '#generate-code-loading-modal',
            generateCodeModal: '#generate-code-modal',
            codeGeneratedNotification: '#code-generated-notification',
            generateVoucherCodeFixedCta: '#generate-voucher-code',
            generateVoucherCodeDiscountText: '#generate-voucher-code-discount',
            errorModalCloseButton: '#generate-voucher-code-error-close',
            printVoucherModal: '#print-voucher-code-modal',
            printVoucherCode: '#print-voucher-code'
        },
        ids: {
            generateCodeModal: 'generate-code-modal',
            generateCodeLoadingModal: 'generate-code-loading-modal',
            errorModal: 'generate-voucher-code-error',
            printVoucherModal: 'print-voucher-code-modal',
            voucherErrorNotification: '#disney-voucher-error'
        },
        state: {
            discount: '',
            showVocherCode: '40074',
            voucherCode: ''
        },
        urls: {
            GenerateVoucher: '/api/sitecore/DisneyKids/GenerateVoucher',
            ActiveVoucher: '/api/sitecore/DisneyKids/ActiveVoucher',
            ErrorPage: '/error/error-page'
        },
        func: {
            init: function (viewData) {
                voucher.func.bindings();
                voucher.func.onPageLoad(viewData);
            },
            bindings: function () {
                $(voucher.elements.generateCodeButton).on('click', voucher.func.generateCode);
                $(voucher.elements.generateVoucher).on('click', voucher.func.issueVoucher);
                $(".vds-notification[data-notification-code='" + voucher.state.showVocherCode + "'] .vds-button")
                    .on('click', voucher.func.showVoucher);
                $(voucher.elements.errorModalCloseButton).on('click', voucher.func.helpers.reloadPage);
            },
            onPageLoad: function (viewData) {
                voucher.state.discount = viewData.Discount;
                if (viewData.IsEligible) {
                    $(voucher.elements.addChildCover).hide();
                    $(voucher.elements.generateVoucherCodeFixedCta).show();
                } else if (viewData.HasGeneratedCode) {
                    $(voucher.elements.addChildCover).hide();
                    $(voucher.elements.codeGeneratedNotification).show();
                } else {
                    $(voucher.elements.addChildCover).show();
                }
            },
            showVoucher: function () {
                $.ajax({
                    type: 'GET',
                    url: voucher.urls.ActiveVoucher,
                    success: voucher.func.showVoucherSuccess,
                    error: voucher.func.showVoucherError
                });
            },
            showVoucherSuccess: function (data) {
                if (data.hasError || data.voucherCode === null) {
                    $(voucher.ids.voucherErrorNotification).show();
                } else {
                    $(voucher.elements.printVoucherCode).text(data.voucherCode);
                    voucher.func.openPrintModal();
                }
            },
            showVoucherError: function (jqxhr) {
                if (jqxhr.statusCode === voucher.httpStatusCode.LoginTimeout) {
                    voucher.func.helpers.reloadPage();
                } else {
                    voucher.func.redirectToErrorPage();
                }
            },
            generateCode: function () {
                const text = $(voucher.elements.generateVoucherCodeDiscountText).text();
                $(voucher.elements.generateVoucherCodeDiscountText).text(text.replace('{{discount}}', voucher.state.discount));
                voucher.func.openGenerateCodeModal();
            },
            issueVoucher: function () {
                voucher.func.closeGenerateCodeModal();
                voucher.func.openLoadingModal();
                $.ajax({
                    type: 'GET',
                    url: voucher.urls.GenerateVoucher,
                    success: voucher.func.issueVoucherSuccess,
                    error: voucher.func.issueVoucherError
                });
            },
            issueVoucherSuccess: function (data) {
                if (data.hasError || data.voucherCode === null) {
                    voucher.func.closeLoadingModal();
                    voucher.func.openErrorModal();
                } else {
                    voucher.func.closeLoadingModal();
                    $(voucher.elements.printVoucherCode).text(data.voucherCode);
                    voucher.func.openPrintModal();
                }
            },
            issueVoucherError: function (jqxhr) {
                if (jqxhr.statusCode === voucher.httpStatusCode.LoginTimeout) {
                    voucher.func.helpers.reloadPage();
                } else {
                    voucher.func.redirectToErrorPage();
                }
            },
            redirectToErrorPage: function () {
                voucher.func.helpers.redirect(voucher.urls.ErrorPage);
            },
            openGenerateCodeModal: function () {
                voucher.func.helpers.openModal(voucher.ids.generateCodeModal);
            },
            openPrintModal: function () {
                voucher.func.helpers.openModal(voucher.ids.printVoucherModal);
            },
            openLoadingModal: function () {
                voucher.func.helpers.openModal(voucher.ids.generateCodeLoadingModal);
            },
            openErrorModal: function () {
                voucher.func.helpers.openModal(voucher.ids.errorModal);
            },
            closeErrorModal: function () {
                voucher.func.helpers.closeModal(voucher.ids.errorModal);
            },
            closeGenerateCodeModal: function () {
                voucher.func.helpers.closeModal(voucher.ids.generateCodeModal);
            },
            closePrintModal: function () {
                voucher.func.helpers.reloadPage();
                voucher.func.helpers.closeModal(voucher.ids.printVoucherModal);
            },
            closeLoadingModal: function () {
                voucher.func.helpers.closeModal(voucher.ids.generateCodeLoadingModal);
            },
            helpers: {
                reloadPage: function () {
                    window.location.reload(true);
                },
                redirect: function (url) {
                    window.location.replace(url);
                },
                openModal: function (id) {
                    fed.openModal(id);
                },
                closeModal: function (id) {
                    fed.closeModal(id);
                }
            }
        }
    };
    return {
        voucherInit: voucher.func.init
    };
})(jQuery, {openModal: openModal, closeModal: closeModal});

$('document').ready(function () {
    if ('disneyKids' === $('#page-data').data('feature')) {
        const viewData = $('#page-data').data('model');
        disneyKids.voucherInit(viewData);
    }
});
